import React       from 'react';
import ReactDom    from 'react-dom';

import Utils       from 'utils';

import ContentsModal from 'contents_modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class InputSchedule extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  update(column, type, value) {
    if( type == 'start_date' ) this.action.bind(this)({ id: column, start_date: value });
    if( type == 'end_date' ) this.action.bind(this)({ id: column, end_date: value });
    if( type == 'delete' ) this.action.bind(this)({ id: column, is_delete: value });
  }
  // -------------------------------------------------------
  
  create() {
    let name = this.schedule_name.value;
    if( name == '' ){
      alert('スケジュールの名称を入力して下さい');
      return;
    }
    
    this.action.bind(this)({ id: Utils.md5(name), name: name, is_original: true });
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  action(params) {
    let schedule = this.props.update.schedule;
    if( schedule == undefined ) schedule = {};
    if( schedule[params.id] == undefined ) schedule[params.id] = {};
    
    schedule[params.id] = Object.assign(schedule[params.id], params);
    this.props.basic_update_ev.bind(this)({ column: 'schedule', value: schedule });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    let items = data.base_list.concat();
    
    let schedule = this.props.update.schedule;
    if( schedule != undefined ){
      for( let i in schedule ) if( schedule[i].is_original === true && schedule[i].is_delete !== true) items.push(schedule[i]);
    }
    
    if( schedule == undefined ) schedule = {};
    
    return (
      <div className="schedule-box">
        { items.map((d, key) => {
          let act = (d.act != undefined) ? d.act : d.id;
          let default_value = (schedule[act] != undefined ) ? schedule[act] : {};
          
          return (
            <InputScheduleForm key={key} item={d} data={data} default_value={default_value} update_ev={this.update.bind(this)} />
          );
        })}
        
        <p className="button plus-schedule" onClick={this.toggleModal.bind(this, true)}>新しいスケジュールを追加する</p>
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {400}
          height    = {130}
          close_ev  = {this.toggleModal.bind(this, false)}
          html      = {(
            <div className="modal-contents">
              <h6>スケジュールの名称</h6>
              <input className="text" type="text" ref={(input) => { this.schedule_name = input }} placeholder="名称を入力して下さい" />
              <p className="button" onClick={this.create.bind(this)}>送信</p>
            </div>
          )}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class InputScheduleForm extends React.Component {
  update(type) {
    if( type == 'start_date' ) this.props.update_ev.bind(this)(this.props.item.id, type, this.start_date.value);
    if( type == 'end_date' ) this.props.update_ev.bind(this)(this.props.item.id, type, this.end_date.value);
  }
  
  delete(type) {
    let chk = confirm('スケジュールを削除してもよろしいですか？');
    if( chk == false ) return;
    
    this.props.update_ev.bind(this)(this.props.item.id, 'delete', true);
  }
  
  render() {
    let item = this.props.item;
    let data = this.props.data;
    let default_value = this.props.default_value;
    
    return (
      <div className="schedule-item">
        <h3>{item.name}</h3>
        
        <div className="schedule-item-date">
          <div className="date-item">
            <h6>開始日</h6>
            <input className="text" type="date" ref={(input) => { this.start_date = input }} onChange={this.update.bind(this, 'start_date')} defaultValue={Utils.setDate(default_value.start_date, 'YYYY-MM-DD')} />
          </div>
          <div className="space">～</div>
          <div className="date-item">
            <h6>終了日</h6>
            <input className="text" type="date" ref={(input) => { this.end_date = input }} onChange={this.update.bind(this, 'end_date')} defaultValue={Utils.setDate(default_value.end_date, 'YYYY-MM-DD')} />
          </div>
        </div>
        
        { (item.is_original === true) &&
          
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>スケジュールを削除する</Tooltip>}>
            <p className="delete" onClick={this.delete.bind(this)}><i className="material-icons">close</i></p>
          </OverlayTrigger>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputSchedule;